import LoadingBar from 'components/LoadingBar'
import s from './LoadingCompetitors.module.css'

const LOADING_COMPETITORS = 5

export const LoadingCompetitors = () => {
  const loadingCompetitorUrl = new Array(LOADING_COMPETITORS).fill(null)

  return (
    <div className={s.wrapper}>
      {loadingCompetitorUrl.map((_, idx) => (
        <div className={s.headerWrapper} key={idx}>
          <div className={s.headerTextImgContainer}>
            <LoadingBar height={40} width={40} borderRadius={4} />
          </div>
          <div className={s.titleWrapper}>
            <LoadingBar width={400} borderRadius={4} />
            <LoadingBar width={300} borderRadius={4} />
          </div>
        </div>
      ))}
    </div>
  )
}
